export const ROUTE_ACTION_ENTITY_TYPE = 'ROUTE_ACTION';

export interface UserSummaryV4 {
  id: number;
  fullname: string;
  username: string;
}

export interface CommentV4 {
  id: string;
  conversationId: string;
  message: string;
  mentions: UserSummaryV4[];
  createdBy: UserSummaryV4;
  createdAt: string;
  updatedAt?: string;
}

export interface ConversationV4 {
  id: string;
  dataSpaceId: number;
  businessUnitId: number;
  entityType: string;
  entityUid: string;
  planId?: string;
  resolved: boolean;
  resolvedBy?: UserSummaryV4;
  resolvedAt?: string;
  createdBy: UserSummaryV4;
  createdAt: string;
  comments: CommentV4[];
}

export interface ConversationsV4Response {
  conversations: ConversationV4[];
}

export interface PostCommentV4Request {
  entityType: string;
  entityUid: string;
  planId?: string;
  message: string;
  mentions?: number[];
}

export interface PostCommentV4Response {
  comment: CommentV4;
  conversationId: string;
}
